// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"30fbea9c988c86c285ec","883":"87528deb9e12e41071b8"}[chunkId] + ".js";
};